import { configureStore } from "@reduxjs/toolkit";

//--------------------- admin --------------------
import { authSlice } from "./slices/admin/session/auth";
import { meSlice } from "./slices/admin/me.slice.js";
import { settingsSlice } from "./slices/admin/settings/settings.slice";
import { toastSlice } from "./slices/common/toast.slice";
import { adminModalSlice } from "./slices/common/adminModal.slice";
import { cmsSlice } from "./slices/admin/cms";
import { rolesSlice } from "./slices/admin/membersAndRoles/roles";
import { accessSlice } from "./slices/admin/membersAndRoles/permission";
import { accessUsersSlice } from "./slices/admin/membersAndRoles/teamMembers";
import { dashboardSlice } from "./slices/admin/dashboard";
import { languagesSlice } from "./slices/admin/dataManagement/language";
import { reportReasonSlice } from "./slices/admin/dataManagement/reportReason";
import { countrySlice } from "./slices/admin/dataManagement/country";
import { userSlice } from "./slices/admin/users";
import { hobbySlice } from "./slices/admin/dataManagement/hobby";
import { employmentSlice } from "./slices/admin/dataManagement/employment";
import { personalitySlice } from "./slices/admin/dataManagement/personality";
import { cultureSlice } from "./slices/admin/dataManagement/culture";
import { relationshipSlice } from "./slices/admin/dataManagement/relationship";
import { sectSlice } from "./slices/admin/dataManagement/sect";
import { announcementSlice } from "./slices/admin/announcement";
import { fullScreenMediaSlice } from "./slices/common/fullScreenMedia.slice";
import { currencySlice } from "./slices/admin/dataManagement/currency";
import { chatReportSlice } from "./slices/admin/chatReport";
import { maliciousWordSlice } from "./slices/admin/dataManagement/maliciousWords";
import { userReportReasonSlice } from "./slices/admin/dataManagement/userReportReason";
import { SubscriptionPlanSlice } from "./slices/admin/SubscriptionPlans";

import { reasonSlice } from "./slices/admin/dataManagement/activityReason";
import { privacyPolicySlice } from "./slices/admin/authPrivacyPolicy";

function configStore() {
  const store = configureStore({
    reducer: {
      auth: authSlice.reducer,
      me: meSlice.reducer,
      dashboard: dashboardSlice.reducer,
      settings: settingsSlice.reducer,
      toast: toastSlice.reducer,
      adminModal: adminModalSlice.reducer,
      fullScreenMedia: fullScreenMediaSlice.reducer,
      cms: cmsSlice.reducer,
      roles: rolesSlice.reducer,
      access: accessSlice.reducer,
      accessUsers: accessUsersSlice.reducer,
      user: userSlice.reducer,
      announcement: announcementSlice.reducer,
      chatReport: chatReportSlice.reducer,
      privacyPolicy: privacyPolicySlice.reducer,

      //datamanagement

      languages: languagesSlice.reducer,
      country: countrySlice.reducer,
      hobby: hobbySlice.reducer,
      employment: employmentSlice.reducer,
      personality: personalitySlice.reducer,
      culture: cultureSlice.reducer,
      relationship: relationshipSlice.reducer,
      sect: sectSlice.reducer,
      currency: currencySlice.reducer,
      reportReason: reportReasonSlice.reducer,
      maliciousWord: maliciousWordSlice.reducer,
      userReportReason: userReportReasonSlice.reducer,
      subscription: SubscriptionPlanSlice.reducer,
      reason: reasonSlice.reducer,
      // Add other reducers if needed
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }),
  });
  return store;
}

export default configStore;
